module.exports = __webpack_public_path__ + "img/ks_yama.1087541d.png";